import React from "react"
import parse, { domToReact } from 'html-react-parser';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import Link from 'components/Link';
import Image from 'components/Image';

import GalleryProvider from "providers/GalleryProvider";
import TwoColumnVideoProvider from "providers/TwoColumnVideoProvider";
import BlockquoteProvider from "providers/BlockquoteProvider";
import CardSliderProvider from "providers/CardSliderProvider";
import TwoColumnProvider from "providers/TwoColumnProvider";
import StatCardProvider from "providers/StatCardProvider";
import InlineVideoProvider from "providers/InlineVideoProvider";

const smartTags = {
	Gallery: GalleryProvider,
	TwoColumnVideo: TwoColumnVideoProvider,
	Blockquote: BlockquoteProvider,
	CardSlider: CardSliderProvider,
	TwoColumn: TwoColumnProvider,
	StatCard: StatCardProvider,
	InlineVideo: InlineVideoProvider,
}

const formatStringToCamelCase = str => {
	const splitted = str.split("-");
	if (splitted.length === 1)return splitted[0];
	return splitted[0] + splitted.slice(1).map(word => word[0].toUpperCase() + word.slice(1)).join("")
};

export const getStyleObjectFromString = str => {
	const style = {};
	str.split(";").forEach(el => {
		const [property, value] = el.split(":");
		if (!property) return;
		const formattedProperty = formatStringToCamelCase(property.trim());
		style[formattedProperty] = value.trim();
	});
	return style;
};

const parserOptions = {
	replace: ({ name, attribs, children }) => {
		if (attribs === undefined)attribs = {};
		if (attribs.style !== undefined && typeof attribs.style === 'string')attribs.style = getStyleObjectFromString(attribs.style);
		switch (name) {
			case "a":
				let Component;
				attribs.className = attribs.class;
				if (attribs.class === 'button') {
					Component = Button;
					delete attribs.class;
					delete attribs.className;
					attribs.variant = 'contained';
				} else Component = Link;
				return <Component {...attribs}>{ domToReact(children, parserOptions) }</Component>

			case "img":
				return (
					<Image {...attribs} alt={attribs.alt} className="content__img" />
				)

			case 'div':
			case 'ul':
			case 'li':
			case 'p':
				const TagName = name;
				return (
					<TagName {...attribs}>
						{ domToReact(children, parserOptions) }
					</TagName>
				)
			
			case 'h1':
			case 'h2':
			case 'h3':
			case 'h4':
			case 'h5':
			case 'h6':
				return <Typography variant={name} {...attribs}>{ domToReact(children, parserOptions) }</Typography>

			case 'smarttag':
				if (!!attribs.component === false)return null;
				const { component } = attribs;
				delete attribs.component;
				for (const key in attribs) {
					if (attribs[key] === 'false')attribs[key] = false;
					if (attribs[key] === 'true')attribs[key] = true;
				}
				if (smartTags[component] !== undefined) {
					const SmartTag = smartTags[component];
					return (
						<>
							<SmartTag {...attribs} />
							{ domToReact(children, parserOptions) }
						</>
					)
				} else {
					// Manually do it
					return <>{component} is not a valid smart tag.</>;
				}

			case 'table':
				return (
					<TableContainer className={'content__table'} component={Paper}>
						<Table>{ domToReact(children, parserOptions) }</Table>
					</TableContainer>
				)

			 case 'thead':
			 	return (
			 		<TableHead>{ domToReact(children, parserOptions) }</TableHead>
			 	)

			 case 'tbody':
			 	return (
			 		<TableBody>{ domToReact(children, parserOptions) }</TableBody>
			 	)

			 case 'tr':
			 	return (
			 		<TableRow>{ domToReact(children, parserOptions) }</TableRow>
			 	)

			 case 'th':
			 case 'td':
			 	return (
			 		<TableCell>{ domToReact(children, parserOptions) }</TableCell>
			 	)

			default:
		}
	}
};

export default function zparse(str, options = parserOptions) {
	if (!str) return "";
	if (typeof str !== 'string')return str;
	return parse(str, options);
}